import { Controller, useFormContext } from 'react-hook-form'

import { IEconomicGroupProps } from './interface'
import { Multi } from '@/components/select/multi'

const EconomicGroup = ({
  control,
  accountKey,
  loadOptions
}: IEconomicGroupProps) => {
  const { setValue } = useFormContext()

  return (
    <Controller
      key={accountKey}
      name='grupoEconomico'
      control={control}
      render={({ field: { onChange, value } }) => (
        <Multi
          value={value}
          onChange={option => {
            onChange(option)
            setValue('unidade', null)
          }}
          label='Grupo econômico'
          loadOptions={loadOptions}
          isMulti={false}
          closeMenuOnSelect
        />
      )}
    />
  )
}

export default EconomicGroup
